import { Yup, type YupTypes } from "@pharmupp/p3-front-commons"

export enum LocationEnum {
  ADDRESS = "address",
  LINE_1 = "line1",
  LINE_2 = "line2",
  POSTAL_CODE = "postalCode",
  CITY = "city",
  LOCATION = "location",
  FRONT_PARKING = "frontParking",
}

export const locationSchema = Yup.object({
  [LocationEnum.ADDRESS]: Yup.object({
    [LocationEnum.LINE_1]: Yup.string()
      .max(60)
      .when("line2", ([line2], schema) =>
        line2
          ? schema.required(
              "La première ligne d'adresse est obligatoire si la seconde est saisie",
            )
          : schema,
      )
      .nullable()
      .default(null),
    [LocationEnum.LINE_2]: Yup.string().max(60).nullable().default(null),
    [LocationEnum.POSTAL_CODE]: Yup.string()
      .matches(/^(\d{5})?$/g, "Le code postal doit être composé de cinq chiffres")
      .when(LocationEnum.LINE_1, ([line1], schema) =>
        line1
          ? schema.required(
              "Le code postal est obligatoire pour compléter l'adresse",
            )
          : schema,
      )
      .nullable()
      .default(null),
    [LocationEnum.CITY]: Yup.string()
      .max(255)
      .when(LocationEnum.LINE_1, ([line1], schema) =>
        line1
          ? schema.required("La ville est obligatoire pour compléter l'adresse")
          : schema,
      )
      .nullable()
      .default(null),
  }).default(null),
  [LocationEnum.LOCATION]: Yup.array().of(Yup.string().required()).nullable(),
  [LocationEnum.FRONT_PARKING]: Yup.boolean().default(false),
})

export type LocationFormValues = YupTypes.InferType<typeof locationSchema>
